module.exports = __webpack_public_path__ + "static/media/qiex.ece08515.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/qiex.png
// module id = 1868
// module chunks = 147